import { ITopolPageProps } from '@/types/TopolPageProps/TopolPageProps';
import { usePage } from '@inertiajs/vue3';
import { computed } from 'vue';

export const useSubscriptionLabel = () => {
    const inertiaProps = usePage<ITopolPageProps>();

    const planName = computed(() =>
        inertiaProps.props.team?.personal_team === false ? 'Team' : 'PRO'
    );

    return { planName };
};
